import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import { Badge, Button, Col, Form, FormLabel, InputGroup, Row, Spinner, Table } from 'react-bootstrap';
import { ArrowLeft, Download, FileEarmarkSpreadsheet, Printer, Search } from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useNavigate } from 'react-router-dom';

const AddonSalesReport = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const animatedComponents = makeAnimated();
    const navigate = useNavigate();

    const accessToken = localStorage.getItem("authToken");
    const [outlets, setOutlets] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [selectedOutletName, setSelectedOutletName] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedCategoryName, setSelectedCategoryName] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [error, setError] = useState('');
    const [clicked, setClicked] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [productList, setProductList] = useState([]);
    const [addonGroup, setAddonGroup] = useState('');
    const [addons, setAddons] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);
    const [selectedAddonValue, setSelectedAddonValue] = useState('');
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);

    console.log("Addon Gorup :", addonGroup);
    

    const getOutlets = async () => {
        try {
          const headers = { Authorization: `Bearer ${accessToken}` };
          const response = await axios.get("outlet", { headers });
    
          if (response?.data?.status === true) {
            const filteredOutlets = response?.data?.data?.outlets.filter((act) => act?.status === "ACTIVE" || "INACTIVE");
            setOutlets(filteredOutlets);
          }
        } catch (error) {
          handleApiError(error);
        }
    };

    const getAddons = async() => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get("addons?page=1&limit=1000", { headers });
            console.log("Addons Groupns :", response?.data?.data?.addons);
            
            setAddons(response?.data?.data?.addons);
        } catch (error) {
            console.log("error :", error);
        }
    }
    
    const getCategoryList = async () => {
        try {
          const headers = { Authorization: `Bearer ${accessToken}` };
          const response = await axios.get("masters/category/get", { headers });
    
          if (response?.data?.status === true) {
            setCategoryList(response?.data?.data?.categories || []);
          }
        } catch (error) {
          handleApiError(error);
        }
    };

    const handleDownloadExcel = async () => {
        setDownloadBtnLoading(true);
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        getAddonsData(adjustedStartDate, adjustedEndDate, selectedOutlet, selectedCategory, addonGroup, selectedAddonValue, true);
    };

    const getAddonsData = async (start, end, outlet, category, addonG, addonV, download) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                "content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }

            const updatedStartDate = start ? start.toISOString().split("T")[0] : null;
            const updatedEndDate = end ? end.toISOString().split("T")[0] : null;

            let api = `addons/addon-sales-report-for-outlet?startDate=${updatedStartDate}&endDate=${updatedEndDate}&outlet=${outlet}&category=${category}`
            if (addonG) {
                let addonId = addonG?.value;
                console.log("addonId :", addonId);
                api += `&addonId=${addonId}`
            }
            if (addonV) {
                let addValue = addonV.value;
                api += `&addonValueId=${addValue    }`
            }

            if (download) {
                api += `&isDownload=${download}`
            }
            const response = await axios.get(api, 
                { 
                    headers ,
                    responseType: download ? 'blob' : 'json'
                }
            );
            console.log("Reponse of report :", response);

            if (download) {
                // Create a blob from the response data
                const blob = new Blob([response.data], { 
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                });
                
                // Create a link element
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                
                // Set the filename for the download
                const fileName = `${selectedOutletName} Addon Sales Report For ${selectedCategoryName} (${updatedStartDate} - ${updatedEndDate}).xlsx`;
                link.download = fileName;
                
                // Append the link to the body and trigger the download
                document.body.appendChild(link);
                link.click();
                
                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
        
                toast.success('Excel file downloaded successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light"
                });
            } else {
                setFilteredData(response?.data?.data);
                setProductList(response?.data?.data);
                toast.success("Data Fetched Successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
            
        } catch (error) {
            console.log("Errorrrrrr :", error);
            setFilteredData([]);
            setProductList([]);
            handleApiError(error);
        } finally {
            setDownloadBtnLoading(false);
        }
    }

    const handleApiError = (error) => {
        let errorMessage = 'An error occurred';
        if (error.response?.status === 406) {
          errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
        } else if (error.response?.status === 404) {
          errorMessage = error.response?.data?.data?.message;
        } else if (error.response?.status === 412) {
          errorMessage = error.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error.response?.data?.error;
        }
    
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
    };

    const handleEndDateChange = (date) => {

        const start = new Date(startDate);
        const end = new Date(date);

        // Remove time part
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const maxEndDate = new Date(start);
        maxEndDate.setDate(start.getDate() + 60);

        if (maxEndDate && startDate && maxEndDate < startDate) {
          setError('End date cannot be earlier than start date');
        } else {
          setError('');
          setEndDate(date);
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setClicked(true);
        setBtnLoading(true);
        
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        
        await getAddonsData(adjustedStartDate, adjustedEndDate, selectedOutlet, selectedCategory, addonGroup, selectedAddonValue);
        
        setBtnLoading(false);
    };

    const handlePrintReport = () => {
        // Calculate totals
        const totalSalesCount = filteredData?.reduce((sum, addon) => sum + (addon.totalAddonSalesCount || 0), 0) || 0;
        const totalDiscount = filteredData?.reduce((sum, addon) => sum + (addon.totalDiscount || 0), 0) || 0;
        const totalTaxable = filteredData?.reduce((sum, addon) => sum + (addon.totalTaxable || 0), 0) || 0;
        const totalTaxAmount = filteredData?.reduce((sum, addon) => sum + (addon.totalTaxAmount || 0), 0) || 0;
        const totalGrandTotal = filteredData?.reduce((sum, addon) => sum + (addon.totalGrandTotal || 0), 0) || 0;

        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        
        // HTML content for printing
        const printContent = `
            <html>
            <head>
                <title>Addon Sales Report</title>
                <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                .print-header { text-align: center; margin-bottom: 20px; }
                .print-title { font-size: 20px; font-weight: bold; margin-bottom: 10px; }
                .print-date { font-size: 14px; color: #666; margin-bottom: 20px; }
                .print-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
                .print-table th { background-color: #f8f9fa; text-align: left; padding: 8px; border: 1px solid #dee2e6; }
                .print-table td { padding: 8px; border: 1px solid #dee2e6; }
                .text-center { text-align: center; }
                .text-end { text-align: right; }
                .text-primary { color: #0d6efd; }
                .fw-semibold { font-weight: 600; }
                .text-success { color: #198754; }
                .bg-light { background-color: #f8f9fa !important; }
                .print-footer { margin-top: 30px; font-size: 12px; color: #666; text-align: center; }
                @page { size: auto; margin: 10mm; }
                </style>
            </head>
            <body>
                <div class="print-header">
                <div class="print-title">Addon Sales Report</div>
                <div class="print-date">Generated on: ${new Date().toLocaleString()}</div>
                </div>
                
                <table class="print-table">
                <thead>
                    <tr>
                    <th width="30">#</th>
                    <th width="80">Outlet</th>
                    <th>Category & Product</th>
                    <th>Addon Group</th>
                    <th>Addon Values</th>
                    <th class="text-center">Sales Count</th>
                    <th class="text-center">Total Sales</th>
                    <th width="80" class="text-end">Discount</th>
                    <th width="80" class="text-end">Taxable</th>
                    <th width="80" class="text-end">Tax</th>
                    <th width="80" class="text-end">Grand Total</th>
                    </tr>
                </thead>
                <tbody>
                    ${filteredData?.length > 0 ? 
                    filteredData.map((addon, index) => `
                        <tr>
                            <td class="text-muted">${index + 1}</td>
                            <td>${addon?.outletName || '--'}</td>
                            <td>
                                <div class="text-dark">${addon?.productName || '--'}</div>
                                <div class="fw-semibold text-primary">${addon?.categoryName || '--'}</div>
                            </td>
                            <td>${addon?.addonTitle || '----'}</td>
                            <td>
                                ${addon?.values?.map(val => `<div>${val.selectedValue}</div>`).join('') || '--'}
                            </td>
                            <td class="text-center">
                                ${addon?.values?.map(val => `<div>${val.totalSaleCount}</div>`).join('') || '--'}
                            </td>
                            <td class="text-center text-success">${addon.totalAddonSalesCount || '0'}</td>
                            <td class="text-end">₹ ${(addon.totalDiscount || 0).toFixed(2)}</td>
                            <td class="text-end">₹ ${(addon.totalTaxable || 0).toFixed(2)}</td>
                            <td class="text-end">₹ ${(addon.totalTaxAmount || 0).toFixed(2)}</td>
                            <td class="text-end text-success">₹ ${(addon.totalGrandTotal || 0).toFixed(2)}</td>
                        </tr>
                    `).join('') + `
                    <tr class="bg-light fw-semibold">
                        <td colspan="6" class="text-end">Total:</td>
                        <td class="text-center text-success">${totalSalesCount}</td>
                        <td class="text-end">₹ ${totalDiscount.toFixed(2)}</td>
                        <td class="text-end">₹ ${totalTaxable.toFixed(2)}</td>
                        <td class="text-end">₹ ${totalTaxAmount.toFixed(2)}</td>
                        <td class="text-end text-success">₹ ${totalGrandTotal.toFixed(2)}</td>
                    </tr>
                    `
                    : `
                    <tr>
                        <td colspan="11" class="text-center">No data available</td>
                    </tr>
                    `
                    }
                </tbody>
                </table>
                
                <div class="print-footer">
                <div>Report generated by the System</div>
                </div>
                
                <script>
                // Print automatically when the window loads
                window.onload = function() {
                    setTimeout(function() {
                    window.print();
                    window.close();
                    }, 200);
                };
                </script>
            </body>
            </html>
        `;

        // Write the content to the new window
        printWindow.document.open();
        printWindow.document.write(printContent);
        printWindow.document.close();
    };

    const handleSearchProducts = () => {
        const trimmedSearchText = searchText.trim().toLowerCase();
        if (trimmedSearchText) {
            const filtered = productList?.filter(product => 
                product?.productName?.toLowerCase().includes(trimmedSearchText)
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(productList);
        }
    };

    const handleAddonValueChange = (e) => {
        console.log("Selected Value :", e?.value);
        setSelectedAddonValue(e);
    }

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    
        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));
        
        setStartDate(start);
        setEndDate(end);
        getOutlets();
        getCategoryList();
        getAddons();
    }, []);
    
    useEffect(() => {
        if (searchText === "" && clicked) {
          getAddonsData(startDate, endDate, selectedOutlet, selectedCategory);
        }
    }, [searchText]);

    useEffect(() => {
        if (addonGroup) {
            const selectedGroup = addons.find(addon => addon._id === addonGroup.value);
            if (selectedGroup && Array.isArray(selectedGroup.addonValues)) {
                const values = selectedGroup.addonValues.map(val => ({
                    value: val._id,
                    label: val.value,
                }));
                setFilteredAddonValues(values);
            } else {
                setFilteredAddonValues([]);
            }
        } else {
            // Clear value and options if group is cleared
            setFilteredAddonValues([]);
            setSelectedAddonValue(null);
        }
    }, [addonGroup, addons]);


    return (
        <React.Fragment>
              <Header onSkin={setSkin} />
                <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                    <div className="card shadow-sm border-0">
                        <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                            <div>
                                <h4 className="mb-0 fw-bold d-inline-block">
                                    <i className="bi bi-sliders me-2"></i>ADDON SALES REPORT
                                </h4>
                            </div>
                            <div>
                                <Button 
                                    variant="outline-secondary" 
                                    size="sm" 
                                    onClick={() => navigate('/reports/all-reports')}
                                    className="me-3 d-flex align-items-center fw-semibold"
                                    style={{ height: '38px' }}
                                >
                                    <ArrowLeft className="me-1" /> Back to Reports
                                </Button>
                            </div>
                        </div>
                        <hr className='mt-0 mb-0' />

                        <div className="card-body">
                            {/* Filters Section */}
                            <div className="p-3 bg-light rounded-3">
                                <Form onSubmit={handleSubmit}>
                                    <Row className="g-3">
                                        <Col md={3}>
                                            <Form.Group controlId="outletSelect">
                                                <Form.Label className="fw-semibold">
                                                    <i className="bi bi-shop me-2"></i>Outlet
                                                </Form.Label>
                                                <Form.Select
                                                    value={selectedOutlet}
                                                    onChange={(e) => 
                                                        {
                                                            setSelectedOutlet(e.target.value)
                                                            setSelectedOutletName(e.target.selectedOptions[0].label)
                                                        }
                                                    }
                                                    className="border-secondary"
                                                >
                                                    <option value="">All Outlets</option>
                                                    {outlets?.map((outlet) => (
                                                    <option key={outlet?._id} value={outlet?._id} label={`${outlet?.name} (${outlet?.city})`}>
                                                        {outlet?.name}
                                                    </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        <Col md={3}>
                                            <Form.Group controlId="categorySelect">
                                                <Form.Label className="fw-semibold">
                                                    <i className="bi bi-tags me-2"></i>Category
                                                </Form.Label>
                                                <Form.Select 
                                                    value={selectedCategory} 
                                                    onChange={(e) => 
                                                        {
                                                            setSelectedCategory(e.target.value)
                                                            setSelectedCategoryName(e.target.selectedOptions[0].label)
                                                        }
                                                    }
                                                    className="border-secondary"
                                                >
                                                    <option value="">All Categories</option>
                                                    {categoryList?.map((category) => (
                                                    <option key={category?._id} value={category?._id} label={category?.name}>
                                                        {category?.name}
                                                    </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        {/* <Col md={2}>
                                            <Form.Group controlId="startDate">
                                                <Form.Label className="fw-semibold">
                                                    <i className="bi bi-calendar me-2"></i>Start Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => setStartDate(date)}
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control border-secondary"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={2}>
                                            <Form.Group controlId="endDate">
                                                <Form.Label className="fw-semibold">
                                                    <i className="bi bi-calendar me-2"></i>End Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={handleEndDateChange}
                                                    dateFormat="dd-MM-yyyy"
                                                    minDate={startDate}
                                                    className="form-control border-secondary"
                                                />
                                            {error && <div className="text-danger small mt-1">{error}</div>}
                                            </Form.Group>
                                        </Col> */}

                                        <Col md={2}>
                                            <Form.Group controlId="startDate">
                                                <Form.Label className="fw-semibold">
                                                    <i className="bi bi-calendar me-2"></i>Start Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setStartDate(date);
                                                        // Reset endDate if it exceeds 60 days from the new startDate
                                                        if (endDate && date && endDate > new Date(date.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                                                        setEndDate(null);
                                                        }
                                                    }}
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control border-secondary"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={2}>
                                            <Form.Group controlId="endDate">
                                                <Form.Label className="fw-semibold">
                                                    <i className="bi bi-calendar me-2"></i>End Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        if (startDate && date > new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                                                        setError("End date cannot be more than 60 days after start date");
                                                        } else {
                                                        setError("");
                                                        handleEndDateChange(date);
                                                        }
                                                    }}
                                                    dateFormat="dd-MM-yyyy"
                                                    minDate={startDate}
                                                    maxDate={startDate ? new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000) : null}
                                                    className="form-control border-secondary"
                                                />
                                                {error && <div className="text-danger small mt-1">{error}</div>}
                                            </Form.Group>
                                        </Col>


                                        <Col md={2} className="d-flex align-items-end">
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                className="w-100"
                                                disabled={!startDate || !endDate || !selectedOutlet || !selectedCategory}
                                            >
                                                {btnLoading ? (
                                                    <Spinner size="sm" animation="border" />
                                                ) : (
                                                    "Generate Report"
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>

                            {/* Search and Actions Section */}
                            <div className="mb-4 p-3 bg-light rounded-3 pt-0">
                                <Row className="g-3 align-items-center">
                                    <Col md="3">
                                        <Form.Label className="fw-semibold">
                                            <i className="bi bi-box me-2"></i>Addon Group
                                        </Form.Label>
                                        <Select
                                            options={addons?.map((addon) => ({
                                                value: addon?._id,
                                                label: addon?.title,
                                            }))}
                                            value={addonGroup}
                                            onChange={(selectedOption) => setAddonGroup(selectedOption)}
                                            classNamePrefix="react-select"
                                            isClearable
                                            placeholder="Select Addon Group"
                                        />
                                    </Col>
                                    <Col md="3">
                                        <Form.Label className="fw-semibold">
                                            <i className="bi bi-collection me-2"></i>Addon Values
                                        </Form.Label>
                                        <Select
                                            components={animatedComponents}
                                            options={filteredAddonValues}
                                            value={selectedAddonValue}
                                            onChange={handleAddonValueChange}
                                            classNamePrefix="select"
                                            placeholder="Select Addon Value"
                                            isClearable
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label className='text-white'>.</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                placeholder="Search by product name"
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                                className="border-secondary"
                                            />
                                                <Button 
                                                    className='w-25'
                                                    variant="outline-secondary"
                                                    onClick={handleSearchProducts}
                                                    disabled={!searchText.trim()}
                                                >
                                                    <Search className='me-1' /> Search
                                                </Button>
                                        </InputGroup>
                                    </Col>
                                    
                                    <Col md={2}>
                                        <div className='d-flex' style={{ flexDirection: 'column' }}>
                                            <Form.Label className='text-white'>.</Form.Label>
                                            <Button
                                                variant="outline-success"
                                                className='fw-semibold'
                                                onClick={handleDownloadExcel}
                                                disabled={!filteredData.length}
                                            >
                                                <FileEarmarkSpreadsheet className="me-2" />
                                                { downloadBtnLoading ? <Spinner size='sm' /> : 'Download Excel' }
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Results Section */}
                            {!clicked ? (
                                <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                                    <div className="text-center">
                                        <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                                        <h5 className="text-muted mt-3">
                                            Please select filters and generate report
                                        </h5>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-responsive border rounded-3">
                                    <Table striped bordered hover className="mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th width="50">#</th>
                                                <th width="100">Outlet</th>
                                                <th>Category & Product</th>
                                                <th>Addon Group</th>
                                                <th>Addon Values</th>
                                                <th className="text-center">Sales Count</th>
                                                <th className="text-center">Total Sales Count</th>
                                                <th width="120" className="text-end">Discount</th>
                                                <th width="120" className="text-end">Taxable</th>
                                                <th width="120" className="text-end">Tax</th>
                                                <th width="120" className="text-end">Grand Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="11" className="text-center py-4">
                                                        <Spinner animation="border" variant="primary" />
                                                        <p className="mt-2 mb-0">Loading product data...</p>
                                                    </td>
                                                </tr>
                                            ) : filteredData?.length > 0 ? (
                                                <>
                                                    {filteredData.map((addon, index) => (
                                                        <tr key={index}>
                                                            <td className="text-muted">{index + 1}</td>
                                                            <td>{addon?.outletName}</td>
                                                            <td>
                                                                <div className="text-dark">{addon?.productName}</div>
                                                                <div className="fw-semibold text-primary">{addon?.categoryName}</div>
                                                            </td>
                                                            <td className='fw-semibold text-muted'>
                                                                {addon?.addonTitle ? `${addon?.addonTitle}` : '----'}
                                                            </td>
                                                            <td>
                                                                {addon?.values?.map((val, i) => (
                                                                    <div key={i}>{val.selectedValue}</div>
                                                                ))}
                                                            </td>
                                                            <td className="text-center">
                                                                {addon?.values?.map((val, i) => (
                                                                    <div key={i}>{val.totalSaleCount}</div>
                                                                ))}
                                                            </td>
                                                            <td className="text-center text-success fw-semibold">{addon.totalAddonSalesCount}</td>
                                                            <td className="text-end">₹ {addon.totalDiscount.toFixed(2)}</td>
                                                            <td className="text-end">₹ {addon.totalTaxable.toFixed(2)}</td>
                                                            <td className="text-end">₹ {addon.totalTaxAmount.toFixed(2)}</td>
                                                            <td className="text-end fw-bold text-success">₹ {addon.totalGrandTotal.toFixed(2)}</td>
                                                        </tr>
                                                    ))}
                                                    {/* Total row */}
                                                    <tr className="fw-bold bg-light">
                                                        <td colSpan="6" className="text-end">Total:</td>
                                                        <td className="text-center text-success">
                                                            {filteredData.reduce((sum, addon) => sum + addon.totalAddonSalesCount, 0)}
                                                        </td>
                                                        <td className="text-end">₹ {filteredData.reduce((sum, addon) => sum + addon.totalDiscount, 0).toFixed(2)}</td>
                                                        <td className="text-end">₹ {filteredData.reduce((sum, addon) => sum + addon.totalTaxable, 0).toFixed(2)}</td>
                                                        <td className="text-end">₹ {filteredData.reduce((sum, addon) => sum + addon.totalTaxAmount, 0).toFixed(2)}</td>
                                                        <td className="text-end text-success">₹ {filteredData.reduce((sum, addon) => sum + addon.totalGrandTotal, 0).toFixed(2)}</td>
                                                    </tr>
                                                </>
                                            ) : (
                                                <tr>
                                                    <td colSpan="11" className="text-center py-4">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
        </React.Fragment>
    )

}

export default AddonSalesReport